import { render } from "./Detail.vue?vue&type=template&id=9c3842d2&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=9c3842d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9c3842d2"

export default script